__turbopack_context__.v({
  "container": "Py0iTa_container",
  "flag": "Py0iTa_flag",
  "flagWrap": "Py0iTa_flagWrap",
});
